import { TPAComponentProps } from '../../types';

export interface PickerProps extends TPAComponentProps {
  value: any;
  onPrev(): void;
  onNext(): void;
  prevDisabled?: boolean;
  nextDisabled?: boolean;
  prevAriaLabel?: string;
  nextAriaLabel?: string;
}
